import { NavLink } from 'react-router-dom'
import { Button } from '../../../components/UI'

export const WIZARD_STEPS = [
  { key: 'foundation', label: 'Cimentación' },
  { key: 'structure', label: 'Estructura' },
  { key: 'masonry', label: 'Mampostería' },
  { key: 'tiles', label: 'Enchapes' },
  { key: 'paint', label: 'Pintura' },
  { key: 'finishes', label: 'Acabados' },
  { key: 'results', label: 'Resultados / Reportes' },
]

export default function MCWizardLayout({ projectId, currentStep, statuses = {}, children, onPrevious, onNext, onCalculate, saving }) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
      <aside className="lg:col-span-1 rounded-lg border border-gray-200 bg-white p-3 space-y-1 h-fit">
        {WIZARD_STEPS.map((step) => {
          const state = statuses[step.key] || 'incomplete'
          const badge = state === 'complete' ? 'OK' : state === 'warning' ? '!' : '•'
          return (
            <NavLink
              key={step.key}
              to={`/material-calculator/projects/${projectId}/wizard/${step.key}`}
              className={({ isActive }) => `block rounded-lg px-3 py-2 text-sm ${isActive ? 'bg-primary-50 text-primary-700' : 'text-gray-700 hover:bg-gray-50'}`}
            >
              {badge} {step.label}
            </NavLink>
          )
        })}
      </aside>

      <div className="lg:col-span-3 space-y-4">
        {children}
        <div className="flex flex-wrap gap-2">
          <Button variant="outline" onClick={onPrevious}>Atrás</Button>
          <Button variant="secondary" onClick={onNext}>Siguiente</Button>
          <Button onClick={onCalculate} loading={saving}>Calcular ahora</Button>
        </div>
      </div>
    </div>
  )
}
